import { render, staticRenderFns } from "./PlayerRegattas.vue?vue&type=template&id=7fda059e&"
import script from "./PlayerRegattas.vue?vue&type=script&lang=js&"
export * from "./PlayerRegattas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports